import React from 'react';

import { Option } from '../../../components/Filters/CheckboxListFilter';

import { TFunction } from 'i18next';
import { WithTranslation, withTranslation } from 'react-i18next';
import RadiobuttonListFilter from '../../../components/Filters/RadiobuttonListFilter';

export interface ProviderFilterProps extends WithTranslation {
    queryParams: URLSearchParams;
    onChange: (changes: { [key: string]: string[] }) => void;
}

const getProviderName = (t: TFunction, value: string) => {
    const key = `settlements.providers.${value || 'undefined'}`;
    const translated = t(key);
    if (translated === key) {
        return value;
    }
    return translated;
};

const ProviderFilter = (
    {
        queryParams,
        t,
        onChange,
    }: ProviderFilterProps
) => {
    const optionValues = [
        'payex',
        'instabank',
        'collector',
        'vipps',
    ];

    const options: Option[] = optionValues.map(value => ({
        label: t(`settlements.providers.${value}`),
        value,
    }));

    const value = queryParams.get('payment_provider');

    return (
        <RadiobuttonListFilter
            label={t('settlements.filter.payment_provider.label', {
                count: 1,
                value: getProviderName(t, value ?? ''),
            })}
            title={t('settlements.filter.payment_provider.title')}
            name="payment_provider"
            value={value ?? ''}
            options={options}
            onApply={(name, value) => {
                onChange({ [name]: [value]});
            }}
            onDelete={name => {
                onChange({ [name]: []});
            }}
        />
    );
};

export default withTranslation()<React.ComponentType<ProviderFilterProps>>(ProviderFilter);
